// extracted by mini-css-extract-plugin
export default {"metric":"feed_event_link_metric__5A-Zf","beta":"feed_event_link_beta__BiYbP","feed_event_link":"feed_event_link_feed_event_link__XjX1j"};